export enum LogTypesEnum {
    COMMENT = 'comment',
    WARNING = 'warning',
    SCORE_CONFIG_CHANGE = 'score_config_change',
}
